import { useEffect, useState } from "react"
import { Keyboard, KeyboardEvent, Platform } from "~/ui/primitives"

export const useKeyboard = (): { keyboardHeight: number } => {
  const [keyboardHeight, setKeyboardHeight] = useState(0)
  let keyboardWillShow = null

  function onKeyboardDidShow(e: KeyboardEvent): void {
    setKeyboardHeight(e.endCoordinates.height)
  }

  useEffect(() => {
    if (Platform.OS === "ios") {
      keyboardWillShow = Keyboard.addListener("keyboardWillShow", onKeyboardDidShow)
    } else {
      keyboardWillShow = Keyboard.addListener("keyboardDidShow", onKeyboardDidShow)
    }
    // Keyboard.addListener("keyboardDidShow", onKeyboardDidShow)
    return (): void => {
      keyboardWillShow?.remove()
      // Keyboard.removeListener("keyboardDidShow", onKeyboardDidShow)
    }
  }, [])

  return { keyboardHeight }
}
